import z from "zod";
import {
  dateOperatorSchema,
  numberOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";

export const filterBonusRefSchema = z.object({
  userId: stringOperatorSchema.optional(),
  amount: numberOperatorSchema.optional(),
  periodId: stringOperatorSchema.optional(),
  ruleRefenrenceRewardId: stringOperatorSchema.optional(),
  createdAt: dateOperatorSchema.optional(),
});

export type FilterBonusRefType = z.infer<typeof filterBonusRefSchema>;
